import foodOrderingAppImage from  '..//images/food_app.png';
import netflixCopy from  '..//images/netflix_copy.png';
import mobileImage from  '..//images/mobile_image.jpg';
import cypressLogo from  '..//images/cypress-logo.png';
import resumeFile from  '..//images/Rashmi_Soundar_Resume.pdf';
import playwrightLogo from  '..//images/playwright_logo.jpeg'
import playwrightGit from  '..//images/playwright_git.png'

export const Bio = {
    name: "Rashmi Soundar",
    roles: [
      "Software QA Engineer",
    ],
    description:
      "I bring a strong motivation and versatility to every project I undertake. Passionate about learning and committed to delivering high-quality results, I approach challenges with a positive attitude. My growth mindset drives me to continuously improve and contribute effectively. I’m excited to leverage my skills to achieve great outcomes and make a meaningful impact.",
    github: "https://github.com/rashmiiyengar",
    resume:
      resumeFile,
    linkedin: "https://www.linkedin.com/in/rashmi-soundar-22a62276/",
  };
  
  export const skills = [
    {
      title: "Test Automation",
      skills: [
        {
          name: "Manual Testing",
          image:
            "https://assets-global.website-files.com/634da4a9e528a8459a2297e7/63595c1d6acf52ae0bf8e35b_6148a40ba84c5b58b315744f_pZa7c3Z0cphRvcP7JYEUmefiv8-Kzx1-d_M9sFS3wXqjqOi6n7xzpyYsavvacN4tnKeLPL5Mlw4WLudX0bmjIpiM6PMQn0dao3fuRJIyfgcc2MrdY6BSyBL-CFh5gfybgeHDr-wg%253Ds0.jpeg",
        },
        {
          name: "Playwright",
          image:
            playwrightLogo
        },
        {
          name: "Selenium",
          image:
            "https://www.mabl.com/hubfs/Selenium-Blog-Featured-Image-18SEP2020-1.png#keepProtocol",
        },
        {
          name: "Cucumber",
          image:
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWgd4XiK73mBrr_-V1QEN7wZ3mXwAZ3gCozxJMifrtUw&s",
        },
        {
            name: "TestNg",
            image:
              "https://banner2.cleanpng.com/20180816/eej/kisspng-testng-logo-software-testing-software-framework-co-udemy-1-free-testng-all-in-one-crash-cours-5b75214eece027.0299854815344028949703.jpg",
          },
        {
            name: "Postman",
            image:
              "https://blog.postman.com/wp-content/uploads/2014/07/logo.png",
          }
      ],
    },
    {
      title: "Programming",
      skills: [
        {
          name: "Java",
          image: "https://1000logos.net/wp-content/uploads/2020/09/Java-Logo.png",
        },
        {
          name: "Javascript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        }
      ],
    },
    {
      title: "Project/Bug Management",
      skills: [
        {
          name: "Jira",
          image:
            "https://1000logos.net/wp-content/uploads/2021/05/Atlassian-Logo-2010s1.png",
        },
        {
          name: "Confluence",
          image:
            "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
            name: "Eclipse",
            image:
              "https://www.iri.com/blog/wp-content/uploads/2012/06/eclipse-logo.png",
          },
      ],
    },
  ];
  
  export const experiences = [
    
    {
      id: 1,
      img: "https://static.wixstatic.com/media/7a2068_3251e2e5b8c846b18f70a93ce4c0778a~mv2.png/v1/fill/w_500,h_500,al_c/7a2068_3251e2e5b8c846b18f70a93ce4c0778a~mv2.png",
      role: "SDET",
      company: "Incredihire",
      date: "Nov 2024 - Present",
      desc: "Currently working as a freelance SDET, Joined the company where no formal test process existed and spearheaded the development of a complete test automation framework from scratch using Playwright.Designed and implemented fixtures for Google authentication login to streamline the testing process.",
      skills: [
        "Manual Testing [Web and Mobile applications]",
        "Playwright",
        "Typescript",
        "JavaScript",
        "SQL",
        "Postman",
        "Functional Testing",
      ]
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTthDJTnc2fQjI_STRj2MeASXbbIBxn6lFGGfwsT8s4Ig&s",
      role: "Senior Software Test Engineer",
      company: "Collaberra Technologies",
      date: "Oct 2022 - Apr 2023",
      desc: "Accountable for the entire QA lifecycle, including designing, implementing, and executing comprehensive test plans and test cases. Proficient in validating mobile applications to ensure functionality, performance, and user experience align with project requirements and quality standards",
      skills: [
        "Manual Testing [Web and Mobile applications]",
        "Selenium",
        "TestNg",
        "Jira",
        "Maven",
        "Postman",
        "Playwright",
        "JavaScript",
      ]
    },
    {
      id: 3,
      img: "https://mma.prnewswire.com/media/1251848/Synechron_Logo.jpg?p=facebook",
      role: "Senior Associate",
      company: "Synechron Technologies",
      date: "Feb 2018 - Sep 2022",
      desc: "Possess a strong understanding of the Software Development Life Cycle (SDLC) and hands-on experience in creating and executing both manual and automated test cases. Demonstrated expertise in ensuring quality deliverables, with professional experience in the Insurance domain.",
      skills: [
        "Manual Testing [Web and Mobile applications]",
        "Selenium",
        "TestNg",
        "Jira",
        "Maven",
        "Postman",
        "JavaScript",
      ],

    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHMEZ7CfGVQoq5kJhSNJNS7JQvaZXAQQp1LdsDTFzLag&s",
      school: "Kalpataru Institute of Technology, Tiptur",
      date: "2013 - 2017",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    }
  ];
  
  export const projects = [
    {
      id: 0,
      title: "Playwright",
      date: "October 2024 - November 2024",
      description:
        "Developed a powerful web automation framework with Playwright, focusing on efficient end-to-end testing and streamlined workflows. The project showcases expertise in modern testing strategies and highlights the ability to build reliable, maintainable solutions for quality assurance.",
      image:playwrightGit
      ,
      tags: [
        "Playwright",
        "Javascript",
        "Api Test",
        "Allure Reports",
      ],
      category: "QA",
      github: "https://github.com/rashmiiyengar/playwright",
    },
    {
      id: 1,
      title: "Selenium Automation",
      date: "Jan 2024 - March",
      description:
        "Selenium Test Automation for EComm Projects",
      image:
        "https://www.mabl.com/hubfs/Selenium-Blog-Featured-Image-18SEP2020-1.png#keepProtocol",
      tags: [
        "Selenium",
        "Java",
        "TestNG",
        "Maven",
        "POM",
      ],
      category: "QA",
      github: "https://github.com/rashmiiyengar/AutomationProject",
      webapp: "rashminetflixclone.netlify.app",
    },
    {
      id: 2,
      title: "Cypress",
      date: "August 2024 - Present",
      description:
        "Automated end-to-end testing for web applications using Cypress, ensuring comprehensive coverage and reliable functionality ",
      image:
      cypressLogo,
      tags: [
        "Cypress",
        "Javascript",
        "Api Test",
        "Reports",
      ],
      category: "QA",
      github: "https://github.com/rashmiiyengar/cypress",
     
    },
    {
      id: 3,
      title: "Mobile Automation",
      date: "July 2024 - Present",
      description:
        " Mobile | android | iOS | Java | OOPS | Appium | TestNG | Maven | ExtentReport | Java mail API | Logging (Log4J2) | Design Patterns (Page Object Model, Singleton) | Page Factories | Jenkins | Data-Driven Testing using JSON file | Expected Data using XML file",
      image:
        mobileImage,
      tags: [
        "Appium",
        "Java",
        "TestNG",
        "Maven",
        "ADB",
        "Android",
        "iOS",
        "XCODE"
      ],
      category: "QA",
      github: "https://github.com/rashmiiyengar/MasterAppiumFramework",
      webapp: "rashminetflixclone.netlify.app",
    },
    {
      id: 4,
      title: "Selenium Automation Framework with CI/CD",
      date: "November 2024 - Present",
      description:
        "Created a Selenium-based automation framework integrated with Docker for isolated test environments and Jenkins for continuous integration and delivery. This project demonstrates expertise in building scalable, reliable, and automated testing pipelines for seamless deployment workflows.",
      image:
        "https://www.mabl.com/hubfs/Selenium-Blog-Featured-Image-18SEP2020-1.png#keepProtocol",
      tags: [
        
        "Selenium",
        "Java",
        "TestNG",
        "Maven",
        "POM",
        "Jenkins",
        "Docker",
        
      ],
      category: "QA",
      github: "https://github.com/rashmiiyengar/SDET_Selenium_Framework",
     
    },
   
    {
      id: 5,
      title: "Netflix Clone",
      date: "Jan 2024 - Mar 2024",
      description:
        "The Netflix clone is built using Reactjs ",
      image:
      netflixCopy,
      tags: [
        "Selenium",
        "Java",
        "TestNG",
        "Maven",
        "POM",
        
      ],
      category: "web app",
      github: "https://github.com/rashmiiyengar/React-netflixgpt",
      webapp: "rashminetflixclone.netlify.app",
    },
    {
      id: 6,
      title: "Food Ordering App",
      date: "March 2024 - April 2024",
      description:
        "Namaste React Live Course from Zero to Hero 🚀 by Akshay Saini(Founder of NamasteDev).",
      image:
      foodOrderingAppImage,
      tags: ["React Js", "Tailwindcss", "Redux"],
      category: "web app",
      github: "https://github.com/rashmiiyengar/React",
      webapp: "https://master--rashmifoodapp.netlify.app/",
      
    },
    
  ];
  